export enum UpcomingLessonsPauseStatus {
  KeepLearning = 'KEEP_LEARNING',
  CancelLessons = 'CANCEL_LESSONS',
}
